'use client';

import { addClassName } from '@hc-frontend/core-utils-format';
import React from 'react';

import { FormGroup } from '../../templates/form-group/form-group';
import type { CheckboxProps, CheckboxVariants } from './checkbox.types';

export function Checkbox<T extends CheckboxVariants>({
  label,
  helpText,
  errorText,
  disabled,
  error,
  type,
  options,
  formGroupProps,
  fieldsetProps: { className: fieldsetClassName, ...fieldsetProps } = {},
  inputContainerProps: {
    className: inputContainerClassName,
    ...inputContainerProps
  } = {},
  inputControlGroupProps,
}: CheckboxProps<T>) {
  const showErrors = error;

  return (
    <FormGroup {...formGroupProps} disabled={disabled} error={showErrors}>
      <fieldset
        {...fieldsetProps}
        className={addClassName(
          'hc-stack-layout--small hc-form-group__stack',
          fieldsetClassName,
        )}
      >
        <legend className="hc-label">{label}</legend>

        {options.map(
          ({
            name: inputName,
            id,
            icon,
            onChange: inputOnChange,
            label: inputLabel,
            value,
            content,
            ...inputProps
          }) => {
            const inputId = id ?? inputName;

            return (
              <div
                key={`${inputId}_${value}`}
                className={addClassName(
                  'hc-form-control',
                  inputContainerClassName,
                )}
                {...inputContainerProps}
              >
                <div
                  className="hc-stack-layout--small"
                  style={{
                    '--hc-stack-layout-space-small': 'var(--space-4-8)',
                  }}
                >
                  <div {...inputControlGroupProps}>
                    <input
                      {...inputProps}
                      disabled={disabled}
                      name={inputName}
                      id={inputId}
                      className="!w-auto"
                      type={type}
                      value={value}
                      onChange={inputOnChange}
                    />
                    <label
                      className="hc-icon-layout--middle hc-label"
                      htmlFor={inputId}
                    >
                      {icon}
                      {inputLabel}
                    </label>
                  </div>
                  {content && <div>{content}</div>}
                </div>
              </div>
            );
          },
        )}
      </fieldset>
      <span className="hc-help-text"> {helpText}</span>
      <span className="hc-error-text">{errorText}</span>
    </FormGroup>
  );
}
